import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-question-simple',
  templateUrl: './dialog-question-simple.component.html'
})

// https://onthecode.co.uk/create-confirm-dialog-angular-material/

export class DialogQuestionSimpleComponent {
  title: string;
  message: string;
  value: string;

  constructor(public dialogRef: MatDialogRef<DialogQuestionSimpleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogQuestionSimpleModel) {
    // Update view with given values
    this.title = data.title;
    this.message = data.message;
    this.value = data.value;
  }

  onConfirm(): void {
    // Close the dialog, return true
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }
}

/**
 * Class to represent confirm dialog model.
 * It has been kept here to keep it as part of shared component.
 */
export class DialogQuestionSimpleModel {
  constructor(public title: string
    , public message: string
    , public value: string
    ) {
  }
}
